
// Namespacing

window.site = (window.site || {});


// Navigation - opened / close

site.Navigation = (function Navigation($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false,
    pageContent = '.main',
    burger  = '.burger',
    nav     = '.navigation',
    navMobile = '.navigation-mobile',
    navLanguage  = '.navigation-language',
    subnavMobile = '.subnav-mobile',
    navCloser = '.navigation-close';

    /**
     * Initializes the class.
     * @public
     */
    var init = function() {

      // Abort if already initialized
      if (inited) {
        return false;
      }

      inited = true;

      // Initiate SidePanel
      initNavigation();
      checkIfFollow();
      triggerMobileSubNav();

      return true;

    };

    // ------------------------------------
    // EVENT HANDLERS
    // ------------------------------------

    var initNavigation = function() {

        animationNavigation();

        $(navCloser).on('click', function(event) {
            event.preventDefault();

            $(pageContent).removeClass('active');
            $(nav).removeClass('active');
            $(navMobile).removeClass('is-active');
            $(burger).removeClass('active');

            $( 'body' ).attr('style','');
        });

        $(pageContent).on('click', function(event) {

            $(this).removeClass('active');
            $(nav).removeClass('active');
            $(navMobile).removeClass('is-active');
            $(burger).removeClass('active');

            $( 'body' ).attr('style','');
        });

        $(window).scroll(function(){
            checkIfFollow();
        });
    };

    var animationNavigation = function() {

      //toggle 3d navigation
      $(burger).on('click', function(event) {
        event.preventDefault();

        toggle3dBlock(!$(pageContent).hasClass('active'));
      });

      function toggle3dBlock(addOrRemove) {
        if(typeof(addOrRemove)==='undefined') addOrRemove = true;
        $(pageContent).toggleClass('active', addOrRemove);
        $(nav).toggleClass('active', addOrRemove);
        $(navMobile).toggleClass('is-active', addOrRemove)
        $('body').css({
          "overflow": "hidden",
          "position": "absolute",
          "width": "100%",
        });
      }

      $.fn.removeClassPrefix = function(prefix) {
          this.each(function(i, el) {
              var classes = el.className.split(" ").filter(function(c) {
                  return c.lastIndexOf(prefix, 0) !== 0;
              });
              el.className = $.trim(classes.join(" "));
          });
          return this;
      };
    };

    var checkIfFollow = function () {

        var st = $(window).scrollTop();

        if( st >= 150 ){
            $(nav).addClass('is-sticky');
        }else{
            $(nav).removeClass('is-sticky');
        }
    };

    var triggerMobileSubNav = function () {

     $(navMobile).on('click', '.js-mobilesub-opener', function(event) {
       event.preventDefault();

       $(navMobile).find('.active').removeClass('active');

       var data = $(this).data('trigger');

      $(data).addClass('active');
     });
    }

    return {
      init: init
    };

}.bind(site, jQuery)());

